import React, { Fragment, useState, useEffect, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import CreateRecruiter from "./CreateRecruiter";
import CustomPagination from "../../pagination/Pagination";
import "../AdminPages.css";

const Recruiters = () => {
  const [collegeName, setCollegeName] = useState();
  const [showCollegeNameContainer, setShowCollegeNameContainer] = useState(
    false
  );
  const [openModifyRecruiter, setOpenModifyRecruiter] = useState(false);
  const [page, setPage] = useState(1);
  const [collegeNameList, setCollegeNameList] = useState();
  const collegeNameRef = useRef();
  const timeoutRef = useRef();
  const [collegeNameLoading, setCollegeNameLoading] = useState(false);
  const [openRecruiter, setOpenRecruiter] = useState(false);
  const [collegeId, setCollegeId] = useState();
  const [loading, setLoading] = useState(false);
  const [modifyData, setModifyData] = useState({});
  const [pageData, setPageData] = useState();

  const getCollegesList = (value) => {
    setCollegeNameLoading(true);
    setShowCollegeNameContainer(true);
    setCollegeNameList([]);
    GetAdminService.getCollegesList(value)
      .then((data) => {
        let recruiterData = data?.data?.college;
        let recruiterName = recruiterData?.map((item) => item.college);
        setCollegeNameList(recruiterName);
        setCollegeNameLoading(false);
      })
      .catch(() => {
        setCollegeNameLoading(false);
      });
  };

  const handleCollegeName = () => {
    clearTimeout(timeoutRef.current);
    setCollegeName(collegeNameRef.current.value);
    if (!collegeNameRef.current.value) {
      setShowCollegeNameContainer(false);
      setCollegeNameList([]);
      setPageData();
    } else {
      timeoutRef.current = setTimeout(() => {
        getCollegesList(collegeNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedCollegeName = (item) => {
    setCollegeNameList([item]);
    setShowCollegeNameContainer(false);
    setCollegeName(item.name);
    setPage(1);
    setCollegeId(item?.id);
  };

  const getRecruiterwithId = (id, pageNum = page) => {
    if (!id) return;
    setLoading(true);
    let obj = {
      college: id,
      page: pageNum,
      role: "recruiter",
    };
    GetAdminService.getRecruiter(obj)
      .then((data) => {
        setPageData(data?.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleSelectedRecruiter = (item) => {
    setModifyData(item);
    setOpenModifyRecruiter(true);
  };

  const handlePageChange = (nextPage) => {
    if (nextPage === page) return;
    setPage(nextPage);
  };

  useEffect(() => {
    if (collegeId) {
      getRecruiterwithId(collegeId, page);
    }
  }, [page, collegeId]);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Recruiters</h2>
              {collegeId && (
                <button
                  className="admin-students-new-btn"
                  onClick={() => setOpenRecruiter(true)}
                >
                  <FontAwesomeIcon icon={faUser} />
                  Add Recruiter
                </button>
              )}
            </div>

            <div className="admin-students-school-selector">
              <label>Select College</label>
              <div className="school-input-wrapper">
                <input
                  ref={collegeNameRef}
                  type="text"
                  placeholder="Type to search college name..."
                  value={collegeName}
                  onChange={handleCollegeName}
                  autoComplete="off"
                />
                {showCollegeNameContainer && (
                  <ul className="school-dropdown">
                    {collegeNameLoading && <CustomLoader />}
                    {collegeNameList?.length > 0 &&
                      collegeNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedCollegeName(item)}
                          key={index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            {pageData && !loading && (
              <div className="admin-students-list-section">
                <div className="admin-student-list-container">
                  <p className="admin-students-heading">Recruiters</p>
                  {pageData?.result?.map((item, index) => (
                    <div
                      key={item?.id || index}
                      className="student-list"
                      onClick={() => handleSelectedRecruiter(item)}
                    >
                      <span className="student-email">{item?.email}</span>
                    </div>
                  ))}
                </div>
                {pageData?.page_list?.length > 1 && (
                  <div className="admin-page-pagination">
                    <CustomPagination
                      count={pageData}
                      pageValue={page}
                      setPage={handlePageChange}
                    />
                  </div>
                )}
              </div>
            )}

            {loading && (
              <div className="admin-page-section">
                <CustomLoader />
              </div>
            )}

            {openRecruiter && (
              <CreateRecruiter
                setOpenRecruiter={setOpenRecruiter}
                modify={false}
                college_id={collegeId}
                recruiterCall={getRecruiterwithId}
              />
            )}
            {openModifyRecruiter && (
              <CreateRecruiter
                setOpenRecruiter={setOpenModifyRecruiter}
                modify={modifyData}
                college_id={collegeId}
                recruiterCall={getRecruiterwithId}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Recruiters;
